import React, { Component } from "react";
import {Button, Row, Col} from 'react-bootstrap'
import _ from 'lodash';

import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

export default class AssignForm extends Component { 
  constructor(props){
    super(props)
   this.state= {
    selectedTemplate:_.find(props.nameList, {"templateName":props.data.templateName})
  }
}

handleSelectTemplate = (e) => {
  this.setState({selectedTemplate: e});
}
reAssign = () => {
  let data = _.cloneDeep(this.props.data);
  data.templateName = this.state.selectedTemplate.templateName
  data = _.omit(data, 'templateValue')
  this.props.closeModal()
  this.props.function.TokenValidation()  
  this.props.function.ReAssignAPI(data)
  this.setState({selectedTemplate:[]})
}
 render(){
   const {data} = this.props
   return(<div className='margingap'>
   <Row>
     <Col><Row>
     <Col md={3}>Region</Col>
     <Col md={1}>:</Col>
     <Col>{data.region.regionName}</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Center</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.center, (item) => {return item.centerName +','}) }</Col></Row></Col>
  </Row>
  <Row>
     <Col><Row>
     <Col md={3}>Client</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.client, (item) => {return item.clientName +','}) }</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Process</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.process, (item) => {return item.processName +','}) }</Col></Row></Col>
   </Row>
    <Row>
   <Col>
    <Row>
    <Col md={3}>Audit</Col>
    <Col md={1}>:</Col>
    <Col>{data.auditType}</Col>
    </Row> 
   </Col>
   <Col>
   Evaluation Template <br/>
   <Picky keepOpen={false}
     value={this.state.selectedTemplate}
     options={this.props.nameList}
     onChange={this.handleSelectTemplate}
     open={false}
     valueKey="templateName"
     labelKey="templateName"
     multiple={false}
     includeSelectAll={false}
     includeFilter={true}
     clearFilterOnClose={true}
     placeholder='Select Template'
     dropdownHeight={600}
   />
    </Col>
    </Row>    
     <br/>
     <Button className='buttonwidth'onClick={this.reAssign} block>Replace Template</Button>
     
</div>)
 }
}    

